<div class="sidenav-content copo-datacenter-sidenav-content" @routeAnimation>
	<div class="copo-datacenter-flex-box">
		<div class="header-container">
			<button (click)="back()" class="back-button-icon" type="button" mat-icon-button>
				<mat-icon svgIcon="md:chevron_left"></mat-icon>
			</button>
			<span class="back-button-title">{{ headerName }}</span>
			<div class="delete-save-container">
				<ng-container *ngIf="!isDefaultView">
					<button (click)="toggleFavorite()" [disabled]="isLoading" class="save-delete-button" color="primary" type="button" mat-button>
						<span *ngIf="!viewToEdit.currentView.isFavorite">Add to favorite</span>
						<span *ngIf="viewToEdit.currentView.isFavorite">Remove from favorite</span>
						<mat-icon *ngIf="!viewToEdit.currentView.isFavorite" iconPositionEnd color="accent" svgIcon="favorite_heart_unselected"></mat-icon>
						<mat-icon *ngIf="viewToEdit.currentView.isFavorite" iconPositionEnd color="accent" svgIcon="favorite_heart_selected"></mat-icon>
					</button>
					<button (click)="shareUserView()" class="save-delete-button" color="primary" type="button" mat-button>
						<span translate>share.view.share</span>
						<mat-icon iconPositionEnd color="accent" svgIcon="share"></mat-icon>
					</button>
					<button (click)="removeUserView()" class="save-delete-button" color="primary" type="button" mat-button>
						<span translate>datacenter.delete</span>
						<mat-icon iconPositionEnd color="accent" svgIcon="delete_bin"></mat-icon>
					</button>
				</ng-container>
				<button (click)="openSaveDialog()" [class.button-disabled]="!this.isValid" [disabled]="!this.isValid" color="primary" class="save-delete-button" type="button" mat-button>
					<span *ngIf="isDefaultView" translate>datacenter.create-new-view</span>
					<mat-icon *ngIf="isDefaultView" iconPositionEnd color="accent" svgIcon="plus_icon"></mat-icon>
					<span *ngIf="!isDefaultView" translate>datacenter.save</span>
					<mat-icon *ngIf="!isDefaultView" iconPositionEnd color="accent" svgIcon="save_disk"></mat-icon>
				</button>
			</div>
		</div>
		<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" #tabGroup>
			<mat-tab class="tab-visible" [label]="filterLabel">
				<copo-datacenter-filter-customization
					class="filter-container"
					[allFilters]="allFilters"
					[addedFilters]="addedFilters"
					[defaultFilters]="defaultFilters"
					></copo-datacenter-filter-customization>
			</mat-tab>
			<mat-tab [label]="layoutLabel">
				<copo-datacenter-save-layout [class.tab-no-display]="typeOfTab==='sorting'"
											(typeOfTab)="setToggle($event)"
											(togglePositionChange)="setTogglePosition($event)"
											(currentColumnStateForSorting)="setColumn($event)"
											[togglePosition]="togglePosition"
											#layoutView></copo-datacenter-save-layout>
				<copo-datacenter-sorting  [class.tab-no-display]="typeOfTab==='layout'"
										(typeOfTab)="setToggle($event)"
										(togglePositionChange)="setTogglePosition($event)"
										[currentColumnStateForSorting]="currentColumnStateForSorting"
										[togglePosition]="togglePosition"
										#sortingView></copo-datacenter-sorting>
			</mat-tab>
		</mat-tab-group>
		<div class="footer-container">
			<button type="button" [class.button-disabled]="!this.isValid" [disabled]="!this.isValid" class="apply-button" cdkFocusInitial
					mat-raised-button color="primary" (click)="setCurrentView()">
				<span translate>datacenter.apply</span>
			</button>
		</div>
	</div>
</div>
